module.exports = __webpack_public_path__ + "img/sce_p1_img_9.326e07dc.png";